module.exports = __webpack_public_path__ + "img/gianhap.be3a343e.svg";